import { SparklesIcon } from "@heroicons/react/24/outline";
import BlogRoutes from "./Blog";
import StaticContentRoutes from "./StaticContent";
import PageManagementRoutes from "./PageManagement";
import CardManagement from "./CardManagement";

const ContentManagement = [
    {
        path: "content-management",
        exact: true,
        showChildren: true,
        sidebarMenu: true,
        displayName: "Content Management",
        icon: SparklesIcon,
        children: [
            ...PageManagementRoutes,
            ...CardManagement,
            ...BlogRoutes,
            ...StaticContentRoutes,
        ],
    },
];

export default ContentManagement;